export const CREATE = 'create';
export const EDIT = 'edit';

export default Object.freeze({
  CREATE,
  EDIT,
});
